import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=7b7c86a1&scoped=true&"
import script from "./BaseCard.vue?vue&type=script&lang=js&"
export * from "./BaseCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=7b7c86a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7c86a1",
  null
  
)

export default component.exports